<template>
  <AbstractSelectMultiple
    :filter="filter"
    :items="items"
    :item-label="itemLabel"
    :item-value="itemValue"
    :active-filters="activeFilters"
    :has-search="hasSearch"
    :disabled="disabled"
    @reset-filter="handleResetFilter"
    @add-filter-item="handleAddFilterItem"
    @remove-filter-item="handleRemoveFilterItem"
  >
    <template #label>
      <slot />
    </template>
  </AbstractSelectMultiple>
</template>

<script setup>
import AbstractSelectMultiple from "../abstract/AbstractSelectMultiple.vue";

defineProps({
  filter: {
    type: String,
    required: true,
  },
  items: {
    type: Array,
    required: true,
    default() {
      return [];
    },
  },
  itemLabel: {
    type: String,
    default: null,
  },
  itemValue: {
    type: String,
    default: null,
  },
  activeFilters: {
    type: Array,
    default() {
      return [];
    },
  },
  hasSearch: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["resetFilter", "addFilterItem", "removeFilterItem"]);

const handleResetFilter = (filter) => {
  emit("resetFilter", filter);
};

const handleAddFilterItem = (item) => {
  emit("addFilterItem", item);
};

const handleRemoveFilterItem = (item) => {
  emit("removeFilterItem", item);
};
</script>
